<template lang="pug">
  .headline.text--size_17(:class="`headline__${variant}`")
    font-awesome-icon.mar_r--10.headline--icon-rocket(icon="rocket")
    strong.mar_r--10.headline--title Highlights
    font-awesome-icon.mar_r--10.headline--icon-arrow(icon="arrow-right")

    | Our monthly EquitiesTracker Insights are now available in our <u><a href="#" @click.prevent="redirectToPage">Research Reports</a></u> page. Check it out!

    //- Added on 03/01/2021
    //- | <strong class="bold__thick">New insights for a new year!</strong> Check out our monthly <u><a href="#" @click.prevent="redirectToPage">EquitiesTracker Insights</a></u> in the Research Reports page
    //- span(style="position: relative; top: 2px;"): font-awesome-icon.mar_l--10(icon="smile")

    //- | 新年快乐 &nbsp; Happy Lunar New Year! Don’t forget to check out the latest <u><a href="#" @click.prevent="redirectToPage">EquitiesTracker Insights</a></u> in our Research Reports page :)


</template>


<script>
  import { ETResearchReport as eventTracking } from '@/lib/eventsTracked';

  export default {
    name: 'headline',

    props: {
      variant: {
        type: String,
        required: false,
        default: 'success'
      }
    },

    methods: {
      redirectToPage() {
        this.$ga.event(...eventTracking.headlineClick);
        this.$router.push({ name: 'stocksResearch', query: { showTab: 2 } });
      }
    }
  }
</script>



<style lang="scss">
  $headline-color-success: #075b07;
  $headline-color-blue: #05446e;

  .headline {
    padding: 20px 20px 18px;
    
    &.headline__success {
      background: $color-success;
      color: #fff;
    }

    &.headline__blue {
      background: #3498db;
      color: #fff;
    }

    &.headline__red {
      background: $color-secondary;
      color: #fff;
    }


  }

  .headline--title {
    display: inline-block;
    padding: 2px 10px;
    border-radius: 4px;

    .headline__success & {
      background: $headline-color-success;
    }

    .headline__blue & {
      background: $headline-color-blue;
    }
    .headline__red & {
      background: #c50000;
      color: #f5f300;
    }
  }

  .headline--icon-rocket,
  .headline--icon-arrow {
    .headline__success & {
      color: $headline-color-success;
    }

    .headline__blue & {
      color: $headline-color-blue;
    }

    .headline__red & {
      color: #871d10;
    }

  }

  .headline--icon-arrow {
    font-size: 90%;
  }

  .headline.headline__success a {
    color: $headline-color-success;

    &:hover {
      color: #fff;
    }
  }
  .headline.headline__blue a {
    color: $headline-color-blue;

    &:hover {
      color: #fff;
    }
  }
  .headline.headline__red a {
    color: #f5f300;

    &:hover {
      color: #fff;
    }
  }
</style>